import React, { useEffect, useState, useContext } from "react";
import { useNavigate, Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { apiFetch } from "../context/AuthContext";
import { useProfile } from "../hooks/useProfile";
import { useMessenger } from "./MessengerContext";

import { useAuth } from "../context/AuthContext";
import { ThemeContext } from "./theme";
import { LanguageContext } from "./LanguageContext"; // ✅ استورد LanguageContext
import { useModal } from '../constant/ModalContext.jsx';
import {
  User,
  LogOut,
  Bell,
  Settings,
  FileText,
  RefreshCcw,
  Home,
  Sun,
  Moon,
  DollarSign,
  Clock,
  Coffee,
  GitPullRequest,
  MessageSquare,
  HelpCircle,
  AlertCircle,      // ✅ دائرة تحذير (الأفضل)
  MessageCircle,    // رسالة دائرية
  AlertTriangle,    // مثلث تحذير
  FileWarning,      // ملف تحذير
  Flag,             // علم
  AlertOctagon,     // مثمن تحذير
  Info,             // معلومات
  MapPinOff,
  Shield,
  Users,
  BarChart3,
  CalendarCheck,
  CalculatorIcon,
  CreditCard,
  LockIcon,
  GitPullRequestIcon,
  BookCheckIcon,
  DollarSignIcon,
  UsersRound,
} from "lucide-react";
// ✅ Import UnreadBadge component
import UnreadBadge from "../components/UnreadBadge";

// Import page components
import ProfessionalProfile from "./(User)Profile_Final";
import Mo3tiAttendancePage from "./(User)attendance_page";
import Mo3tiDocumentsPage from "./(Employee)SelfService";
import Mo3tiLeavePage from "./(User)leave_Managment";
import Mo3tiSettingsPage from "./settings_Final";
import Mo3tiSalaryPage from "./(User)salary_Final";

import Calendar from './Calendar.js';
import { mo3tiThemes } from "./mo3tiThemes";
import SidebarWithTopbar from "./sidebar2.js";
import MessengerPage from "./MessagesPage.jsx";
import EscalationPage from "./escalation.js";
import AdminLevelConfigurationPage from "./AdminLevelConfiguration.js";
// DashboardManager components for admin view
import Dashboard from "./dashboard_Final/index.js";
import EmployeesTableadmin from "./EmployeeTable";
import Reports from "./Reports_Final/Reports.js";
import Attendance from "./Attendance";
import Mo3tiAdminDocumentRequests from "./Mo3tiAdminDocumentRequests";
import ExcelSalaryProcessorWithTheme from "./TaxCalc";
import Payroll from "./payroll.js";
import Mo3tiAdvancementManagement from "./mo3tiAdvanceRequest.js";
import LeaveApprovalPage from "./adminLeavePage.js";
import EmployeeActionsPage from "./changesPage.js";
import GroupsManagement from "./groupsManagement.js";
import ViewTypeSwitcher from '../components/ViewTypeSwitcher';
// ✅ إضافة الترجمات
const translations = {
  en: {
    // Navigation
    profile: "Profile",
    salaryBenefits: "Salary",
    attendance: "Attendance",
    leaveManagement: "Leave Management",
    employeeSelfServices: "Self Services",
    messages: "Messages",
    calendar: "Calendar",
    settings: "Settings ",
    escalation: "Escalation",
    groups: "Groups",

    // Status Messages
    allowLocationAccess: "Please allow location access...",
    accessRestricted: "Access Restricted",
    outsideOfficeArea: "You are outside the office area",
    distanceFromOffice: "Distance from office",
    meters: "meters",
    moveCloserToOffice: "Move closer to office to access",

    // Feature Lock
    featureNotAvailable: "This feature is not available for your organization. Please contact your administrator.",

    // View Mode
    adminView: "Admin View",
    managerView: "Manager View",
    switchToAdminView: "Switch to Admin View",
    switchToManagerView: "Switch to Manager View",

    // Admin/Nav
    dashboard: "Dashboard",
    employees: "Employees",
    reports: "Reports",
    documents: "Documents",
    leave: "Leave",
    solfa: "Solfa",
    payroll: "Payroll",
    taxCalculator: "Tax Calculator",

    // Powered By
    poweredBy: "Powered by",
  },
  ar: {
    // Navigation
    profile: "الملف الشخصي",
    salaryBenefits: "الراتب ",
    attendance: "الحضور",
    leaveManagement: " الإجازات",
    employeeSelfServices: "الخدمات  ",
    messages: "الرسائل",
    calendar: "التقويم",
    settings: "الإعدادات ",
    escalation: "الشكاوى", // ✅ أضف هذا السطر
    groups: "المجموعات",

    // Status Messages
    allowLocationAccess: "الرجاء السماح بالوصول للموقع...",
    accessRestricted: "الوصول محظور",
    outsideOfficeArea: "أنت خارج منطقة المكتب",
    distanceFromOffice: "المسافة من المكتب",
    meters: "متر",
    moveCloserToOffice: "اقترب من المكتب للوصول إلى",

    // Feature Lock
    featureNotAvailable: "هذه الميزة غير متاحة لمؤسستك. يرجى الاتصال بالمسؤول.",

    // View Mode
    adminView: "عرض الإداري",
    managerView: "عرض المدير",
    switchToAdminView: "التبديل إلى عرض الإداري",
    switchToManagerView: "التبديل إلى عرض المدير",

    // Admin/Nav
    dashboard: "لوحة التحكم",
    employees: "الموظفين",
    reports: "التقارير",
    documents: "المستندات",
    leave: "الإجازات",
    solfa: "السلف",
    payroll: "الرواتب",
    taxCalculator: "حاسبة الضرائب",

    // Powered By
    poweredBy: "مدعوم من",
  }
};
const allowedArea = {
  lat: process.env.REACT_APP_OFFICE_LATITUDE,
  lng: process.env.REACT_APP_OFFICE_LONGITUDE,
  radius: 10000, // in meters
};

// Helper: calculate distance between two lat/lng in meters (Haversine formula)
function getDistance(lat1, lon1, lat2, lon2) {
  const R = 6371000; // Earth radius in m
  const toRad = (deg) => (deg * Math.PI) / 180;

  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
    Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // distance in meters
}

const Mo3tiUserProfile = () => {
  // ============ HOOKS AND STATE ============
  const { user, logout } = useAuth();
  const { profile } = useProfile();
  const navigate = useNavigate();
  const { theme, setTheme } = useContext(ThemeContext);
  const { language } = useContext(LanguageContext); // ✅ احصل على اللغة
  const isRTL = language === 'ar'; // ✅ حدد اتجاه الصفحة
  const t = translations[language]; // ✅ احصل على الترجمات
  const { showModal } = useModal();

  // State management
  const [notifications, setNotifications] = useState(3);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [unreadMessages, setUnreadMessages] = useState(0);

  // 🔹 Add location state
  const [userLocation, setUserLocation] = useState(null);
  const [locationError, setLocationError] = useState(null);
  const { conversations: messengerConversations, socket, isConnected } = useMessenger();

  // ✅ Unread messages state for badge display

  const [modulePermissions, setModulePermissions] = useState(null);
  const [loadingPermissions, setLoadingPermissions] = useState(true);
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const [viewMode, setViewMode] = useState(() => {
    return localStorage.getItem('viewType') || 'user'; 
  });

  const [currentPage, setCurrentPage] = useState(() => {
    return viewMode === 'user' ? 'professionalProfile' : 'dashboard'; 
  });

  // View mode state - admin or manager

  // Check if user has an admin level assigned
  const hasAdminLevel = () => {
    try {
      const adminLevelData = localStorage.getItem('adminLevel');
      if (adminLevelData) {
        const adminLevel = JSON.parse(adminLevelData);
        return adminLevel && (adminLevel.modules?.length > 0 || adminLevel.adminLevelId);
      }
    } catch (e) {
      console.error('Error checking admin level:', e);
    }
    return false;
  };

  // Toggle between admin and manager view
  const toggleViewMode = () => {
    if (!hasAdminLevel()) {
      console.warn('User does not have admin level assigned');
      return;
    }
    const newMode = viewMode === 'admin' ? 'manager' : 'admin';
    setViewMode(newMode);
    localStorage.setItem('userViewMode', newMode);

    // Navigate based on view mode
    if (newMode === 'admin') {
      // Navigate to admin configuration page
      navigate('/admin-level-configuration');
    } else {
      // Navigate back to user profile
      navigate('/userprofile/professionalProfile');
    }
  };
// If MessengerContext already has conversations loaded (Messages page), use that as the primary source
  useEffect(() => {
    try {
      if (Array.isArray(messengerConversations) && messengerConversations.length > 0) {
        const totalFromContext = messengerConversations.reduce((s, c) => {
          const u = c.unread ?? c.unreadCount ?? c.unread_count ?? c.unreads ?? 0;
          return s + (Number(u) || 0);
        }, 0);
        console.log('[DashboardManager] Using MessengerContext unread total:', totalFromContext);
        setUnreadMessages(totalFromContext);
      }
    } catch (err) {
      console.warn('[DashboardManager] Error computing unread from MessengerContext', err);
    }
  }, [messengerConversations]);

  // Fetch user location on mount
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setUserLocation({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          });
        },
        (err) => {
          console.error("Error getting location:", err);
          setLocationError(t.allowLocationAccess);
        }
      );
    } else {
      setLocationError("Geolocation is not supported in this browser.");
    }
  }, [t]);

  useEffect(() => {
    setCurrentPage(viewMode === 'user' ? 'professionalProfile' : 'dashboard');
  }, [viewMode]);

  useEffect(() => {
    const fetchModulePermissions = async () => {
      try {
        const clientName = profile?.clientName || localStorage.getItem("clientName") || "";
        if (!clientName) {
          setLoadingPermissions(false);
          return;
        }

        const response = await apiFetch(
          `${BASE_URL}/api/configurations/${encodeURIComponent(clientName)}`,
          { method: 'GET' }
        );

        if (response.ok) {
          const data = await response.json();
          setModulePermissions(data?.data);
        } else {
          setModulePermissions({ privateMessaging: false });
        }
      } catch (error) {
        console.error("Error fetching module permissions:", error);
        setModulePermissions({ privateMessaging: false });
      } finally {
        setLoadingPermissions(false);
      }
    };

    fetchModulePermissions();
  }, []);

  // جلب عدد الرسائل غير المقروءة (مرة واحدة فقط عند التحميل)
  useEffect(() => {
    const fetchUnreadMessages = async () => {
      try {
        if (!BASE_URL) {
          console.log('[Userprofile] BASE_URL not set');
          return;
        }

        console.log('[Userprofile] Fetching initial unread count from:', `${BASE_URL}/api/private-messages/conversations`);
        
        const response = await apiFetch(
          `${BASE_URL}/api/private-messages/conversations`,
          { method: 'GET' }
        );

        console.log('[Userprofile] Response status:', response.status, response.ok);

        if (response.ok) {
          const data = await response.json();
          console.log('[Userprofile] Raw API Response:', data);
          
          // البيانات قد تأتي كـ array مباشرة أو داخل object
          let conversations = [];
          if (Array.isArray(data)) {
            conversations = data;
          } else if (data.data && Array.isArray(data.data)) {
            conversations = data.data;
          } else if (data.conversations && Array.isArray(data.conversations)) {
            conversations = data.conversations;
          }
          
          console.log('[Userprofile] Parsed conversations array length:', conversations.length);
          
          // حساب إجمالي الرسائل غير المقروءة
          let total = 0;
          conversations.forEach((conv, index) => {
            // البحث عن unreadCount بطرق مختلفة
            const unreadCount = 
              conv.unreadCount ?? 
              conv.unread_count ?? 
              conv.unreadMessagesCount ?? 
              conv.unreads ?? 
              0;
            
            total += Number(unreadCount) || 0;
            
            if (index < 3) { // لا نطبع جميعها، فقط أول 3
              console.log(`[Userprofile] Conversation: "${conv.recipientName || conv.name || 'Unknown'}" - Unread: ${unreadCount}`);
            }
          });

          console.log('[Userprofile] ✅ Initial unread messages count:', total);
          setUnreadMessages(total);
        } else {
          console.error('[Userprofile] ❌ API returned error status:', response.status, await response.text());
        }
      } catch (error) {
        console.error('[Userprofile] ❌ Error fetching unread messages:', error);
      }
    };

    fetchUnreadMessages();
    // No polling - we'll use real-time socket events instead
  }, [BASE_URL]);

  // Real-time socket listener for new messages
  useEffect(() => {
    if (!socket || !isConnected) {
      console.log('[Userprofile] Socket not ready for unread messages listener');
      return;
    }

    console.log('[Userprofile] Setting up real-time message listeners');

    // Increment counter when new message is received
    const handleMessageReceived = (data) => {
      console.log('[Userprofile] 📩 New message received:', data);
      setUnreadMessages(prev => {
        const newCount = prev + 1;
        console.log(`[Userprofile] Unread count: ${prev} → ${newCount}`);
        return newCount;
      });
    };

    // Decrement counter when messages are marked as read
    const handleMessagesRead = (data) => {
      console.log('[Userprofile] ✓ Messages marked as read:', data);
      if (data.count) {
        setUnreadMessages(prev => {
          const newCount = Math.max(0, prev - data.count);
          console.log(`[Userprofile] Unread count: ${prev} → ${newCount}`);
          return newCount;
        });
      }
    };

    socket.on('private_message:received', handleMessageReceived);
    socket.on('private_message:read', handleMessagesRead);

    console.log('[Userprofile] ✅ Real-time message listeners active');

    return () => {
      socket.off('private_message:received', handleMessageReceived);
      socket.off('private_message:read', handleMessagesRead);
      console.log('[Userprofile] Cleaned up message listeners');
    };
  }, [socket, isConnected]);

  // ============ HELPER FUNCTIONS ============
  const createAvatar = (name) => {
    if (!name) return "UN";
    const parts = name.split(" ");
    return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase();
  };

  // ============ DATA CONFIGURATION ============
  const currentTheme = isDarkMode ? mo3tiThemes.dark : mo3tiThemes.light;
  const isPrivateMessagingEnabled = modulePermissions?.privateMessaging ?? false;

  // Mapping between page names and module names for permission checking
  const pageToModuleMap = {
    "professionalProfile": null, // Profile is always visible
    "salary": "payroll",
    "messages": "messages",
    "employee-services": "documents",
    "calendar": "calendar",
    "attendance": "attendance",
    "leave-management": "leaves",
    "escalation": "escalation",
    "settings": null, // Settings always visible
    // Admin view pages
    "dashboard": null, // Dashboard always visible
    "employees": "employees",
    "reports": "reports",
    "Mo3tiAdminDocumentRequests": "documents",
    "LeaveApprovalPage": "leaves",
    "Mo3tiAdvancementManagement": "advancements",
    "ChangesPage": "changesPage",
    "Payroll": "payroll",
    "TaxCalculator": "payroll",
  };

  // Pages that should only appear in Admin View (not in Manager View)
  const adminOnlyPages = ["dashboard", "employees", "reports", "Mo3tiAdminDocumentRequests", "LeaveApprovalPage", "Mo3tiAdvancementManagement", "ChangesPage", "Payroll", "TaxCalculator"];

  // Navigation menu items for Manager View
  const userNavItems = [
    { icon: User, text: t.profile, page: "professionalProfile" },
    {
      icon: Clock,
      text: t.attendance,
      page: "attendance",
    },
    {
      icon: DollarSign,
      text: t.salaryBenefits,
      page: "salary",
    },
    {
      icon: MessageSquare,
      text: isPrivateMessagingEnabled ? t.messages : t.messagesLocked,
      page: "messages",
      locked: !isPrivateMessagingEnabled,
      badge: unreadMessages,
      badgeColor: '#ef4444',
    },
    {
      icon: FileText,
      text: t.employeeSelfServices,
      page: "employee-services",
    },
    {
      icon: Home,
      text: t.calendar,
      page: "calendar",
    },
    {
      icon: Coffee,
      text: t.leaveManagement,
      page: "leave-management",
    },
    {
      icon: AlertTriangle,
      text: t.escalation,
      page: "escalation",
    },
    {
      icon: UsersRound,
      text: t.groups,
      page: "groups",
    },
    {
      icon: Settings,
      text: t.settings,
      page: "settings",
    },
  ];

  // Navigation menu items for Admin View
  const adminNavItems = [
    { icon: Home, text: t.dashboard || "Dashboard", page: "dashboard" },
    { icon: Users, text: t.employees || "Employees", page: "employees" },
    { icon: CalendarCheck, text: t.attendance || "Attendance", page: "attendance" },
    { icon: BarChart3, text: t.reports || "Reports", page: "reports" },
    { icon: Home, text: t.calendar || "Calendar", page: "calendar" },
    {
      icon: MessageSquare,
      text: isPrivateMessagingEnabled ? (t.messages || "Messages") : (t.messages + " 🔒" || "Messages 🔒"),
      page: "messages",
      locked: !isPrivateMessagingEnabled,
    },
    { icon: BookCheckIcon, text: t.documents || "Documents", page: "Mo3tiAdminDocumentRequests" },
    { icon: Coffee, text: t.leave || "Leave", page: "LeaveApprovalPage" },
    { icon: DollarSignIcon, text: t.solfa || "Solfa", page: "Mo3tiAdvancementManagement" },
    { icon: GitPullRequestIcon, text: t.employeeSelfServices || "Employee Changes", page: "ChangesPage" },
    { icon: CreditCard, text: t.payroll || "Payroll", page: "Payroll" },
    { icon: CalculatorIcon, text: t.taxCalculator || "Tax Calculator", page: "TaxCalculator" },
    { icon: LockIcon, text: t.settings || "Settings", page: "Settings" },
  ];

  // Select nav items based on viewMode
  const allNavItems = viewMode === 'user' ? userNavItems : adminNavItems;  // Changed from 'manager'

  // Filter navigation items based on admin level permissions
  const { hasModuleAccess } = useAuth();
  const navItems = allNavItems.filter(item => {
    // Always visible items in both views
    if (viewMode === 'manager') {
      // Manager view: always show profile and settings, hide admin-only pages
      if (item.page === "professionalProfile" || item.page === "settings") {
        return true;
      }
      return true;
    }

    // Admin view: filter based on admin level permissions
    if (viewMode === 'admin') {
      // Dashboard and Settings always visible
      if (item.page === "dashboard" || item.page === "Settings") {
        return true;
      }

      // Get the required module for this page
      const requiredModule = pageToModuleMap[item.page];

      // If no module mapping exists, show the item (backward compatibility)
      if (!requiredModule) return true;

      // Check if user has access to the required module
      return hasModuleAccess(requiredModule);
    }

    return true;
  });

  // Employee data — profile (from /users/me) is source of truth;
  // localStorage serves as an immediate fallback (populated at login).
  const _phone     = profile?.employeePhone         || localStorage.getItem("employeePhone")         || "";
  const _emergency = profile?.emergencyPhoneNumber  || localStorage.getItem("emergencyPhoneNumber")  || "";
  const _name      = profile?.employeeName          || localStorage.getItem("employeeName")          || "موظف غير محدد";
  const employeeData = {
    id:               profile?.infinityCode                  || localStorage.getItem("infinityCode")                  || "EMP001",
    name:             _name,
    position:         profile?.employeeType                  || localStorage.getItem("employeeType")                  || "--",
    department:       profile?.employeeType                  || localStorage.getItem("employeeType")                  || "--",
    email:            profile?.employeeEmail                 || localStorage.getItem("employeeEmail")                 || localStorage.getItem("email") || "employee@company.com",
    phone:            _phone ? "+20" + _phone : "--",
    address:          profile?.address                       || localStorage.getItem("address")                       || localStorage.getItem("location") || "--",
    joinDate:         profile?.hiringDate                    || localStorage.getItem("hiringDate")                    || null,
    employeeId:       profile?.infinityCode                  || localStorage.getItem("infinityCode")                  || "EMP001",
    manager:          profile?.firstLineManagerName          || localStorage.getItem("firstLineManagerName")          || "--",
    status:           profile?.employeeState                 || localStorage.getItem("employeeState")                 || "Active",
    avatar:           createAvatar(_name),
    birthDate:        profile?.DoB                           || localStorage.getItem("DoB")                           || null,
    nationalId:       profile?.nationalId                    || localStorage.getItem("nationalId")                    || "--",
    emergencyContact: _emergency ? "+20" + _emergency : "--",
    workLocation:     profile?.location                      || localStorage.getItem("location")                      || "--",
    firstLevelManager: profile?.firstLineManagerInfinityCode || localStorage.getItem("firstLineManagerInfinityCode") || "--",
  };

  // ============ EVENT HANDLERS ============
const handleViewTypeChange = (type) => {
  setViewMode(type);
  localStorage.setItem('viewType', type);

  if (type === 'user') {
    // نفس الصفحة، مش محتاج navigate
    navigate('/userprofilemanager/professionalProfile', { replace: true });
  } else if (type === 'admin') {
    navigate('/userprofileadmin/professionalProfile', { replace: true });  // أو dashboard
  } else if (type === 'manager') {
    navigate('/DashboardManager/dashboard', { replace: true });
  }
};
  const handleLogout = () => {
    try {
      logout();
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error);
      navigate("/login");
    }
  };

  const handleSwitchManager = () => {
    try {
      navigate("/dashboard");
    } catch (error) {
      console.error("switch error:", error);
      navigate("/userprofile");
    }
  };

  const handlePageChange = (page) => {
    const navItem = navItems.find(item => item.page === page);
    if (navItem?.locked) {
      const title = (t && t.notice) || 'Notice';
      const message = navItem.lockMessage || undefined; // allow ModalContext to use localized default
      showModal({ title, message, options: { requestAccessEndpoint: process.env.REACT_APP_BASE_URL ? `${process.env.REACT_APP_BASE_URL}/api/request-module-access` : null, module: navItem.page } });
      return;
    }
    setCurrentPage(page);
    navigate(`/userprofile/${page}`);
  };

  const toggleTheme = () => {
    const newDarkMode = !isDarkMode;
    setIsDarkMode(newDarkMode);
    if (setTheme) {
      setTheme(newDarkMode ? "dark" : "light");
    }
  };

  // ============ CREATE PAGE PROPS ============
  const pageProps = {
    employeeData,
    theme: currentTheme,
    isDarkMode
  };

  // ============ RENDER FUNCTIONS ============
  const renderMessages = () => {
    // If no location yet
    if (!userLocation && !locationError) {
      return <div>📍 {t.allowLocationAccess}</div>;
    }

    if (locationError) {
      return (
        <div style={{ color: "red", padding: "20px" }}>{locationError}</div>
      );
    }

    // Calculate distance
    const distance = getDistance(
      userLocation.lat,
      userLocation.lng,
      allowedArea.lat,
      allowedArea.lng
    );

    if (distance > allowedArea.radius) {
      return (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="absolute inset-0 bg-black/20 backdrop-blur-sm" />

          <div className="relative bg-white/80 dark:bg-slate-900/80 backdrop-blur-lg rounded-3xl shadow-2xl p-8 flex flex-col items-center max-w-xs text-center border border-red-400/20">
            <div className="w-24 h-24 flex items-center justify-center mb-5 relative">
              <MapPinOff
                size={60}
                className="text-red-500/20 dark:text-red-400/20"
              />
              <div className="absolute inset-0 rounded-full bg-red-500/10 blur-xl animate-pulse" />
            </div>

            <h2 className="text-2xl font-extrabold text-red-600 dark:text-red-400 mb-2">
              {t.accessRestricted}
            </h2>

            <p className="text-gray-700 dark:text-gray-300 mb-4">
              {t.outsideOfficeArea}
            </p>

            <div className="w-full bg-red-50/30 dark:bg-slate-800/30 rounded-xl p-4 mb-4 shadow-inner">
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">
                {t.distanceFromOffice}
              </p>
              <p className="text-xl font-bold text-gray-900 dark:text-gray-100">
                {Math.round(distance).toLocaleString()}{" "}
                <span className="text-sm font-medium">{t.meters}</span>
              </p>
            </div>

            <p className="text-sm text-gray-600 dark:text-gray-400">
              {t.moveCloserToOffice}{" "}
              <strong className="font-semibold text-gray-900 dark:text-gray-100">
                {t.messages}
              </strong>.
            </p>
          </div>
        </div>
      );
    }

    // ✅ Allowed → show messages page
    return <MessengerPage />;
  };

  // ============ RENDER THEME TOGGLE ============
  const renderThemeToggle = () => (
    <button
      style={{
        padding: "8px",
        borderRadius: "12px",
        cursor: "pointer",
        color: theme === "light" ? "#0f172a" : "white",
        background: theme === "light" ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.1)",
        border: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.3s ease",
      }}
      onClick={toggleTheme}
      title={theme === "light" ? "تبديل إلى الوضع المظلم" : "تبديل إلى الوضع الفاتح"}
    >
      {theme === "light" ? <Moon size={20} /> : <Sun size={20} />}
    </button>
  );

  // ============ STYLES ============
  const containerStyles = {
    minHeight: "100vh",
    background: currentTheme?.background?.gradient || "linear-gradient(135deg, #66ea9fff 0%, #764ba2 100%)",
    fontFamily: currentTheme?.fonts?.primary || "Arial, sans-serif",
    position: "relative",
    overflow: "hidden",
    transition: "all 0.3s ease",
    direction: isRTL ? "rtl" : "ltr", // ✅ اتجاه الصفحة
  };

  const backgroundOverlayStyles = currentTheme?.background?.overlay || {};
  const decorativeContainerStyles = currentTheme?.background?.decorative?.container || {};
  const circle1Styles = currentTheme?.background?.decorative?.circle1 || {};
  const circle2Styles = currentTheme?.background?.decorative?.circle2 || {};

  const globalStyles = `
    * { 
      box-sizing: border-box; 
    }
    
    body {
      margin: 0;
      padding: 0;
      font-family: ${isRTL ? "'Cairo', 'Tajawal', " : ""}${currentTheme?.fonts?.primary || "Arial, sans-serif"};
    }
    
    input::placeholder { 
      color: ${currentTheme?.colors?.textSecondary || "#666"}; 
    }
    
    ::-webkit-scrollbar { 
      width: 8px; 
    }
    
    ::-webkit-scrollbar-track { 
      background: ${currentTheme?.colors?.scrollbar?.track || "#f1f1f1"}; 
      border-radius: 4px; 
    }
    
    ::-webkit-scrollbar-thumb { 
      background: ${currentTheme?.colors?.scrollbar?.thumb || "#c1c1c1"}; 
      border-radius: 4px; 
    }
    
    ::-webkit-scrollbar-thumb:hover { 
      background: ${currentTheme?.colors?.scrollbar?.thumbHover || "#a8a8a8"}; 
    }
    
    /* Responsive Design */
    @media (max-width: 768px) {
      .mo3ti-sidebar { 
        width: 100% !important; 
        ${isRTL ? 'right' : 'left'}: ${sidebarOpen ? "0" : "-100%"} !important; 
        z-index: 1000;
      }
      
      .mo3ti-main { 
        ${isRTL ? 'margin-right' : 'margin-left'}: 0 !important; 
      }
      
      .mo3ti-topbar { 
        padding: 12px 16px !important; 
      }
      
      .mo3ti-content { 
        padding: 20px 16px !important; 
      }
      
      .mo3ti-search { 
        width: 200px !important; 
      }
    }
    
    @media (max-width: 480px) {
      .mo3ti-content { 
        padding: 16px 12px !important; 
      }
      
      .mo3ti-search { 
        width: 150px !important; 
      }
    }
  `;

  if (loadingPermissions) {
    return (
      <div style={{ ...containerStyles, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ color: 'white', fontSize: '18px' }}>Loading permissions...</div>
      </div>
    );
  }

  // ============ MAIN RENDER ============
  return (
    <div style={containerStyles}>
      {/* Background Elements */}
      <div style={backgroundOverlayStyles} />
      <div style={decorativeContainerStyles}>
        <div style={circle1Styles} />
        <div style={circle2Styles} />
      </div>

      {/* Sidebar with Topbar */}
      <SidebarWithTopbar
        navItems={navItems}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        user={user}
        notifications={notifications}
        handleLogout={handleLogout}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        themeToggle={renderThemeToggle()}
        viewModeSwitcher={
          <ViewTypeSwitcher
            viewType={viewMode}
            onSelect={handleViewTypeChange}  // Use new handler
            hasAdminLevel={hasAdminLevel}
            role={localStorage.getItem('role')}
          />
        }
      >
        <div style={{
          padding: "0",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          marginTop: 40,
        }}>
          <Routes key={viewMode}>
            {/* User View Routes */}
            {viewMode === 'user' && (
              <>
                <Route path="/" element={<ProfessionalProfile />} />
                <Route path="/professionalProfile" element={<ProfessionalProfile />} />
                <Route path="/salary" element={<Mo3tiSalaryPage {...pageProps} />} />
                <Route path="/escalation" element={<EscalationPage {...pageProps} />} />
                <Route path="/groups" element={<GroupsManagement />} />
                <Route path="/attendance" element={<Mo3tiAttendancePage {...pageProps} />} />
                <Route path="/employee-services" element={<Mo3tiDocumentsPage {...pageProps} />} />
                <Route path="/calendar" element={<Calendar {...pageProps} />} />
                <Route
                  path="/messages"
                  element={
                    isPrivateMessagingEnabled ? (
                      renderMessages()
                    ) : (
                      <Navigate to="/userprofile" replace />
                    )
                  }
                />
                <Route path="/leave-management" element={<Mo3tiLeavePage {...pageProps} />} />
                <Route path="/settings" element={<Mo3tiSettingsPage {...pageProps} toggleTheme={toggleTheme} />} />
                <Route path="*" element={<Navigate to="/userprofile/professionalProfile" replace />} />
              </>
            )}

            {/* Admin View Routes */}
            {viewMode === 'admin' && (
              <>
                <Route path="/" element={<Dashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/employees" element={<EmployeesTableadmin />} />
                <Route path="/attendance" element={<Attendance />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route
                  path="/messages"
                  element={
                    isPrivateMessagingEnabled ? (
                      <MessengerPage />
                    ) : (
                      <Navigate to="/userprofile" replace />
                    )
                  }
                />
                <Route path="/Mo3tiAdminDocumentRequests" element={<Mo3tiAdminDocumentRequests />} />
                <Route path="/LeaveApprovalPage" element={<LeaveApprovalPage />} />
                <Route path="/Mo3tiAdvancementManagement" element={<Mo3tiAdvancementManagement />} />
                <Route path="/ChangesPage" element={<EmployeeActionsPage />} />
                <Route path="/Payroll" element={<Payroll />} />
                <Route path="/TaxCalculator" element={<ExcelSalaryProcessorWithTheme />} />
                <Route path="/Settings" element={<Mo3tiSettingsPage {...pageProps} toggleTheme={toggleTheme} />} />
                <Route path="*" element={<Navigate to="/userprofile" replace />} />
              </>
            )}
          </Routes>
        </div>
      </SidebarWithTopbar>

      {/* Global Styles */}
      <style>{globalStyles}</style>
    </div>
  );
};

export default Mo3tiUserProfile;
